module.exports = __webpack_public_path__ + "mainassets/img/logo-white-header-2x.f264e9f9.png";